var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-x margin-top-1 margin-bottom-1 align-bottom"},[_c('radio-filter',{attrs:{"option-list":_vm.optionList,"callback":_vm.navigateToPlan,"selected-value":_vm.$route.name}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }